// Todas as logos de instituição saem do ícone ATUAL do app de cada uma na Google Play
// (auditoria e refação de 17/out/2026), no padrão badge 60x60 com fundo cheio. O pacote de
// cada app e o método usado estão em docs/kb/institution-logos.md: é por lá que se refaz uma
// logo quando o banco troca o ícone. O kit do Figma ficou só para quem não tem mais app
// (Banco Original, Ben); as bandeiras de cartão e os dois glifos de vale (alimentação,
// transporte) não são marca de instituição.
//
// O que não é cópia direta do ícone:
// - Cartão de loja usa a marca da LOJA, nunca a do emissor ("Realize", "Midway", "Carrefour
//   Soluções Financeiras"): renner, riachuelo, carrefour e amazon vêm do app da loja.
// - lecard: sem os cantinhos de moldura do ícone e com a palavra ampliada 1,3x.
// - amazon: a textura de papelão e a sombra do sorriso achatadas em 4 cores antes do tracer.
// - Desenhadas à mão com as medidas do PNG, porque têm degradê ou relevo que o tracer não
//   faz: samsung-wallet, caixa (o X), ailos, pluxee (o ícone é 3D), sofisa e a faixa do
//   recargapay.
// - Letra ou traço fino ampliado 1,1–1,3x em volta do centro para ler a 40px (inter, nomad,
//   brb, digio, riachuelo, banrisul, daycoval, unicred, swile…): o <g transform> do arquivo
//   diz quanto.
import bancoDoBrasilXml from '../assets/institutions/banco-do-brasil.svg';
import banestesXml from '../assets/institutions/banestes.svg';
import bradescoXml from '../assets/institutions/bradesco.svg';
import c6Xml from '../assets/institutions/c6.svg';
import caixaXml from '../assets/institutions/caixa.svg';
import interXml from '../assets/institutions/inter.svg';
import itauXml from '../assets/institutions/itau.svg';
import itauPersonnaliteXml from '../assets/institutions/itau-personnalite.svg';
import mercadoPagoXml from '../assets/institutions/mercado-pago.svg';
import nomadXml from '../assets/institutions/nomad.svg';
import nubankXml from '../assets/institutions/nubank.svg';
import picpayXml from '../assets/institutions/picpay.svg';
import santanderXml from '../assets/institutions/santander.svg';
import agibankXml from '../assets/institutions/agibank.svg';
import ailosXml from '../assets/institutions/ailos.svg';
import banrisulXml from '../assets/institutions/banrisul.svg';
import bmgXml from '../assets/institutions/bmg.svg';
import bnbXml from '../assets/institutions/bnb.svg';
import brbXml from '../assets/institutions/brb.svg';
import btgXml from '../assets/institutions/btg.svg';
import bvXml from '../assets/institutions/bv.svg';
import coraXml from '../assets/institutions/cora.svg';
import contabilizeiXml from '../assets/institutions/contabilizei.svg';
import cresolXml from '../assets/institutions/cresol.svg';
import daycovalXml from '../assets/institutions/daycoval.svg';
import digioXml from '../assets/institutions/digio.svg';
import mercantilXml from '../assets/institutions/mercantil.svg';
import neonXml from '../assets/institutions/neon.svg';
import originalXml from '../assets/institutions/original.svg';
import panXml from '../assets/institutions/pan.svg';
import portoXml from '../assets/institutions/porto.svg';
import safraXml from '../assets/institutions/safra.svg';
import sicoobXml from '../assets/institutions/sicoob.svg';
import sicrediXml from '../assets/institutions/sicredi.svg';
import unicredXml from '../assets/institutions/unicred.svg';
import xpXml from '../assets/institutions/xp.svg';
import amazonXml from '../assets/institutions/amazon.svg';
import carrefourXml from '../assets/institutions/carrefour.svg';
import pagbankXml from '../assets/institutions/pagbank.svg';
import rennerXml from '../assets/institutions/renner.svg';
import riachueloXml from '../assets/institutions/riachuelo.svg';
import googleWalletXml from '../assets/institutions/google-wallet.svg';
import samsungWalletXml from '../assets/institutions/samsung-wallet.svg';
import valeAlimentacaoXml from '../assets/institutions/vale-alimentacao.svg';
import valeTransporteXml from '../assets/institutions/vale-transporte.svg';
import cajuXml from '../assets/institutions/caju.svg';
import ifoodXml from '../assets/institutions/ifood.svg';
import aleloXml from '../assets/institutions/alelo.svg';
import pluxeeXml from '../assets/institutions/pluxee.svg';
import ticketXml from '../assets/institutions/ticket.svg';
import vrXml from '../assets/institutions/vr.svg';
import flashXml from '../assets/institutions/flash.svg';
import benXml from '../assets/institutions/ben.svg';
import swileXml from '../assets/institutions/swile.svg';
import revolutXml from '../assets/institutions/revolut.svg';
import wiipoXml from '../assets/institutions/wiipo.svg';
import lecardXml from '../assets/institutions/lecard.svg';
import pay99Xml from '../assets/institutions/99pay.svg';
import meliuzXml from '../assets/institutions/meliuz.svg';
import pagaleveXml from '../assets/institutions/pagaleve.svg';
import infinitepayXml from '../assets/institutions/infinitepay.svg';
import mareeXml from '../assets/institutions/maree.svg';
import tonXml from '../assets/institutions/ton.svg';
import sofisaXml from '../assets/institutions/sofisa.svg';
import ricoXml from '../assets/institutions/rico.svg';
import clearXml from '../assets/institutions/clear.svg';
import agoraXml from '../assets/institutions/agora.svg';
import recargapayXml from '../assets/institutions/recargapay.svg';
import citiXml from '../assets/institutions/citi.svg';
import bankOfAmericaXml from '../assets/institutions/bank-of-america.svg';
import amexXml from '../assets/institutions/amex.svg';
import paypalXml from '../assets/institutions/paypal.svg';
import wiseXml from '../assets/institutions/wise.svg';
import chaseXml from '../assets/institutions/chase.svg';
import wellsFargoXml from '../assets/institutions/wells-fargo.svg';
import capitalOneXml from '../assets/institutions/capital-one.svg';
import usBankXml from '../assets/institutions/us-bank.svg';
import pncXml from '../assets/institutions/pnc.svg';
import truistXml from '../assets/institutions/truist.svg';
import tdBankXml from '../assets/institutions/td-bank.svg';
import allyXml from '../assets/institutions/ally.svg';
import discoverXml from '../assets/institutions/discover.svg';
import chimeXml from '../assets/institutions/chime.svg';
import sofiXml from '../assets/institutions/sofi.svg';
import venmoXml from '../assets/institutions/venmo.svg';
import cashAppXml from '../assets/institutions/cash-app.svg';
import schwabXml from '../assets/institutions/schwab.svg';
import robinhoodXml from '../assets/institutions/robinhood.svg';
import brandVisaXml from '../assets/institutions/brand-visa.svg';
import brandMastercardXml from '../assets/institutions/brand-mastercard.svg';
import brandEloXml from '../assets/institutions/brand-elo.svg';
import brandAmexXml from '../assets/institutions/brand-amex.svg';
import brandHipercardXml from '../assets/institutions/brand-hipercard.svg';

export const institutionLogoMap = {
    'banco-do-brasil': bancoDoBrasilXml,
    banestes: banestesXml,
    bradesco: bradescoXml,
    c6: c6Xml,
    caixa: caixaXml,
    inter: interXml,
    itau: itauXml,
    'itau-personnalite': itauPersonnaliteXml,
    'mercado-pago': mercadoPagoXml,
    nomad: nomadXml,
    nubank: nubankXml,
    picpay: picpayXml,
    santander: santanderXml,
    safra: safraXml,
    neon: neonXml,
    original: originalXml,
    pan: panXml,
    bmg: bmgXml,
    agibank: agibankXml,
    digio: digioXml,
    cora: coraXml,
    contabilizei: contabilizeiXml,
    bv: bvXml,
    daycoval: daycovalXml,
    porto: portoXml,
    mercantil: mercantilXml,
    btg: btgXml,
    xp: xpXml,
    sicoob: sicoobXml,
    sicredi: sicrediXml,
    ailos: ailosXml,
    unicred: unicredXml,
    cresol: cresolXml,
    brb: brbXml,
    banrisul: banrisulXml,
    bnb: bnbXml,
    amazon: amazonXml,
    carrefour: carrefourXml,
    pagbank: pagbankXml,
    renner: rennerXml,
    riachuelo: riachueloXml,
    'google-wallet': googleWalletXml,
    'samsung-wallet': samsungWalletXml,
    'vale-alimentacao': valeAlimentacaoXml,
    'vale-transporte': valeTransporteXml,
    caju: cajuXml,
    ifood: ifoodXml,
    alelo: aleloXml,
    pluxee: pluxeeXml,
    ticket: ticketXml,
    vr: vrXml,
    flash: flashXml,
    ben: benXml,
    swile: swileXml,
    wiipo: wiipoXml,
    lecard: lecardXml,
    '99pay': pay99Xml,
    meliuz: meliuzXml,
    pagaleve: pagaleveXml,
    infinitepay: infinitepayXml,
    maree: mareeXml,
    ton: tonXml,
    sofisa: sofisaXml,
    rico: ricoXml,
    clear: clearXml,
    agora: agoraXml,
    recargapay: recargapayXml,
    revolut: revolutXml,
    citi: citiXml,
    'bank-of-america': bankOfAmericaXml,
    amex: amexXml,
    paypal: paypalXml,
    wise: wiseXml,
    chase: chaseXml,
    'wells-fargo': wellsFargoXml,
    'capital-one': capitalOneXml,
    'us-bank': usBankXml,
    pnc: pncXml,
    truist: truistXml,
    'td-bank': tdBankXml,
    ally: allyXml,
    discover: discoverXml,
    chime: chimeXml,
    sofi: sofiXml,
    venmo: venmoXml,
    'cash-app': cashAppXml,
    schwab: schwabXml,
    robinhood: robinhoodXml,
    // Bandeiras (redes de cartão). Prefixadas pra não colidir com banco de mesmo nome —
    // 'amex' já é a American Express como INSTITUIÇÃO na lista de bancos dos EUA.
    'brand-visa': brandVisaXml,
    'brand-mastercard': brandMastercardXml,
    'brand-elo': brandEloXml,
    'brand-amex': brandAmexXml,
    'brand-hipercard': brandHipercardXml,
} as const;

export type InstitutionLogoKey = keyof typeof institutionLogoMap;

const institutionAliases: Record<InstitutionLogoKey, string[]> = {
    // "ourocard" é o nome do CARTÃO do BB e não contém "banco do brasil" nem "bb" —
    // sem o alias explícito o cartão não se liga ao emissor (mesmo caso do bradescard).
    'banco-do-brasil': ['banco do brasil', 'bb', 'ourocard'],
    banestes: ['banestes', 'banco do estado do espirito santo', 'banco do espirito santo'],
    // O Banco Bradescard (emissor dos cartões de loja: Cencosud/GBarbosa, C&A, Ipiranga)
    // é do grupo Bradesco e não tem logo própria em nenhuma fonte aberta — cai na árvore
    // vermelha do Bradesco, que é a marca do grupo. Note que "bradescard" NÃO contém
    // "bradesco" (…scard vs …sco), então sem este alias explícito ele não resolveria.
    bradesco: ['bradesco', 'bradescard'],
    c6: ['c6', 'c6 bank'],
    caixa: ['caixa', 'caixa economica', 'caixa economica federal', 'cef'],
    inter: ['inter', 'banco inter'],
    // Antes do itau: o match é por includes e "itau personnalite" contém "itau",
    // então a entrada mais específica precisa vir primeiro.
    'itau-personnalite': ['itau personnalite', 'personnalite', 'itau pers'],
    // "itaucard" já cairia aqui por `includes` ("itaucard" contém "itau"), mas quem casa
    // apelido dentro de TEXTO LIVRE compara por palavra inteira (lib/invoicePaymentHint.ts)
    // e ali "ITAUCARD" não contém a palavra "itau" — por isso o alias explícito.
    itau: ['itau', 'itaucard', 'itau unibanco'],
    'mercado-pago': ['mercado pago', 'mercadopago'],
    nomad: ['nomad', 'nomad global'],
    nubank: ['nubank', 'nu pagamentos', 'nu bank'],
    picpay: ['picpay'],
    santander: ['santander'],
    safra: ['safra', 'banco safra'],
    neon: ['neon'],
    original: ['banco original', 'original'],
    pan: ['banco pan', 'panamericano'],
    bmg: ['banco bmg', 'bmg'],
    agibank: ['agibank', 'agi bank'],
    digio: ['digio'],
    cora: ['cora'],
    contabilizei: ['contabilizei'],
    bv: ['banco bv', 'banco votorantim', 'votorantim'],
    daycoval: ['daycoval', 'banco daycoval'],
    porto: ['porto bank', 'porto seguro'],
    mercantil: ['banco mercantil', 'mercantil do brasil'],
    btg: ['btg pactual', 'btg'],
    xp: ['xp investimentos', 'banco xp'],
    sicoob: ['sicoob'],
    sicredi: ['sicredi'],
    ailos: ['ailos', 'viacredi', 'cooperativa ailos'],
    unicred: ['unicred'],
    cresol: ['cresol'],
    brb: ['banco de brasilia', 'brb'],
    banrisul: ['banrisul', 'banco do estado do rio grande do sul'],
    bnb: ['banco do nordeste', 'banco do nordeste do brasil'],
    // Cartões de loja: o alias cobre a LOJA e o EMISSOR, porque a fatura vem com um
    // ou com o outro ("Midway" na do Riachuelo, "Realize" na do Renner, "Banco CSF"
    // na do Carrefour).
    // O Cartão Amazon (da Bradescard) só pelo nome inteiro: "amazon" sozinho é a LOJA e está
    // em toda compra feita lá — o palpite de pagamento de fatura acharia que um Pix para a
    // Amazon paga o cartão. A chave casa sozinha quem escreve só "Amazon" no banco.
    amazon: ['cartao amazon', 'amazon mastercard'],
    carrefour: ['carrefour', 'banco csf', 'carrefour solucoes financeiras'],
    pagbank: ['pagbank', 'pagseguro', 'pag seguro'],
    renner: ['renner', 'lojas renner', 'meu cartao renner', 'realize'],
    riachuelo: ['riachuelo', 'midway', 'rchlo'],
    // Carteiras: o alias cobre as duas gerações do nome (o Google Pay virou Google
    // Wallet; o Samsung Pay virou Samsung Wallet e sobrevive como submarca).
    'google-wallet': ['google wallet', 'google pay', 'gpay', 'carteira do google'],
    'samsung-wallet': ['samsung wallet', 'samsung pay', 'spay'],
    // Genérico: só termos amplos. NÃO colocar "beneficios" aqui — colide (via includes) com
    // ifood/vr/flash/ben, que têm "benefícios" no nome e cairiam neste ícone genérico.
    'vale-alimentacao': [
        'vale alimentacao', 'vale refeicao', 'cartao alimentacao', 'cartao refeicao',
        'alimentacao', 'refeicao',
    ],
    'vale-transporte': [
        'vale transporte', 'transporte', 'bilhete unico', 'riocard', 'top nordeste',
    ],
    caju: ['caju', 'cartao caju'],
    ifood: ['ifood', 'ifood beneficios', 'ifood card', 'cartao ifood'],
    alelo: ['alelo', 'cartao alelo'],
    // Pluxee é o novo nome da Sodexo (rebrand 2023) — mantém "sodexo" resolvendo aqui.
    pluxee: ['pluxee', 'sodexo', 'cartao sodexo'],
    ticket: ['ticket', 'ticket restaurante', 'ticket alimentacao', 'edenred'],
    vr: ['vr', 'vr beneficios', 'vale refeicao vr'],
    flash: ['flash', 'flash beneficios', 'cartao flash'],
    ben: ['ben', 'ben beneficios', 'ben visa vale'],
    swile: ['swile', 'cartao swile', 'vee', 'veepay'],
    // "flex" sozinho NÃO entra: casa (via includes) com qualquer conta batizada de "flex".
    wiipo: ['wiipo', 'wiipo flex', 'cartao wiipo'],
    // "le card" sozinho NÃO entra: casa (via includes) com "Apple Card" e "Simple Card".
    // Nem "le card alimentacao"/"le card beneficios": o genérico 'vale-alimentacao' e o "ben"
    // da Ben (que está dentro de "beneficios") vêm antes no objeto e venceriam.
    lecard: ['lecard', 'cartao le card'],
    // "99" sozinho NÃO entra: casaria (via includes) qualquer conta com 99 no nome e o
    // próprio app de corridas. O da corrida é outro app — aqui é só a carteira.
    '99pay': ['99pay', '99 pay'],
    meliuz: ['meliuz'],
    // "leve" sozinho NÃO entra: casa (via includes) com qualquer conta batizada de
    // "leve". "paga leve" cobre quem escreve o nome separado.
    pagaleve: ['pagaleve', 'paga leve'],
    // "infinite" sozinho NÃO entra: casaria (via includes) o "Visa Infinite" de qualquer banco.
    infinitepay: ['infinitepay', 'infinite pay'],
    // A conta nasceu ShopeePay e o crédito se chama SParcelado/SCrédito — e tem quem batize
    // a conta ou o cartão só de "Shopee". Todos caem na marca atual.
    maree: ['maree', 'shopeepay', 'shopee pay', 'shopee', 'sparcelado', 'scredito'],
    // "ton" sozinho NÃO entra: casaria (via includes) Antonio, Milton, Boston. O nome exato
    // "Ton" já resolve pela própria chave; aqui só as formas compostas. "stone" também não:
    // a Conta Stone é outra marca.
    ton: ['conta ton', 'cartao ton', 'ton stone', 'stone ton'],
    sofisa: ['sofisa'],
    // "rico" sozinho NÃO entra: casaria (via includes) Américo, Federico, Enrico. O nome exato
    // "Rico" já resolve pela própria chave; aqui só as formas compostas, como no Ton.
    rico: ['rico investimentos', 'rico corretora', 'corretora rico', 'conta rico', 'cartao rico'],
    // Corretoras do grupo XP pedidas nas avaliações da Play (17–18/10/2026). Nenhuma das duas
    // entra sozinha: "clear" casaria (via includes) "nuclear"; "agora" é palavra comum — uma
    // conta "Reserva agora" ganharia a logo. O nome exato ("Clear", "Ágora") resolve pela chave
    // (o normalize tira o acento); aqui só as formas compostas, como no Rico.
    clear: ['clear corretora', 'corretora clear', 'clear investimentos', 'clear ctvm', 'conta clear'],
    agora: ['agora investimentos', 'agora corretora', 'corretora agora', 'conta agora investimentos'],
    // "recarga" sozinho NÃO entra: é a palavra da recarga de celular, não a marca.
    recargapay: ['recargapay', 'recarga pay'],
    revolut: ['revolut'],
    // EUA — aliases em EN porque é o que o usuário digita. Lembrar que o normalize
    // troca pontuação por espaço: 'U.S. Bank' vira 'u s bank' (por isso os dois aliases).
    citi: ['citi', 'citibank'],
    'bank-of-america': ['bank of america', 'bofa', 'bankofamerica', 'merrill lynch', 'merrill'],
    amex: ['american express', 'amex'],
    paypal: ['paypal', 'pay pal'],
    wise: ['wise', 'transferwise'],
    chase: ['chase', 'jpmorgan chase', 'jp morgan', 'j p morgan', 'jpmorgan'],
    'wells-fargo': ['wells fargo', 'wellsfargo'],
    'capital-one': ['capital one', 'capitalone'],
    'us-bank': ['us bank', 'u s bank', 'usbank', 'us bancorp', 'u s bancorp'],
    pnc: ['pnc', 'pnc bank'],
    truist: ['truist', 'suntrust', 'bb t'],
    // Sem alias 'td' solto: o match por includes pegaria qualquer nome contendo "ltda".
    'td-bank': ['td bank', 'toronto dominion'],
    ally: ['ally', 'ally bank', 'ally financial'],
    discover: ['discover', 'discover bank', 'discover card'],
    chime: ['chime'],
    // "sofi" sozinho NÃO entra: via includes casava o Sofisa (todo cartão do banco BR ganhava a
    // logo americana) e a "Sofia" de qualquer conta batizada com o nome. O nome exato "SoFi" já
    // resolve pela própria chave; aqui só as formas compostas, como no Ton.
    sofi: ['social finance', 'sofi bank', 'sofi checking', 'sofi savings', 'sofi money', 'sofi credit', 'sofi invest'],
    venmo: ['venmo'],
    'cash-app': ['cash app', 'cashapp', 'square cash'],
    schwab: ['charles schwab', 'schwab'],
    robinhood: ['robinhood'],
    // Bandeira NUNCA é reconhecida pelo nome do cartão: 'elo' casa (via includes) com
    // "amarelo"/"Angelo", 'visa' com "Visa Infinite" de qualquer banco. Quem escolhe
    // bandeira é o usuário, no seletor — por isso a lista de aliases fica vazia.
    'brand-visa': [],
    'brand-mastercard': [],
    'brand-elo': [],
    'brand-amex': [],
    'brand-hipercard': [],
};

// Opções do seletor agrupadas por tipo. Vale/benefícios ficam numa seção própria, abaixo dos
// bancos, pra não se misturarem com eles no grid. `titleKey` aponta pro namespace common
// (logoSelector.groups.*) — o título é traduzido na renderização, não aqui.
// `id` existe pra ordenação por locale: usuário em EN vê os bancos US primeiro
// (ver InstitutionLogoSelector).
export type InstitutionLogoGroupId = 'brands' | 'banksBr' | 'banksUs' | 'benefits';

export const institutionLogoGroups: {
    id: InstitutionLogoGroupId;
    titleKey: `logoSelector.groups.${InstitutionLogoGroupId}`;
    options: { key: InstitutionLogoKey; label: string }[];
}[] = [
    // Bandeiras primeiro, e em TODO idioma: rede de cartão não tem região (ver o filtro
    // por locale no InstitutionLogoSelector, que só separa bancos BR de bancos US).
    {
        id: 'brands',
        titleKey: 'logoSelector.groups.brands',
        options: [
            { key: 'brand-visa', label: 'Visa' },
            { key: 'brand-mastercard', label: 'Mastercard' },
            { key: 'brand-elo', label: 'Elo' },
            { key: 'brand-amex', label: 'Amex' },
            { key: 'brand-hipercard', label: 'Hipercard' },
        ],
    },
    {
        id: 'banksBr',
        titleKey: 'logoSelector.groups.banksBr',
        options: [
            { key: 'banco-do-brasil', label: 'Banco do Brasil' },
            { key: 'banestes', label: 'Banestes' },
            { key: 'bradesco', label: 'Bradesco' },
            { key: 'c6', label: 'C6 Bank' },
            { key: 'caixa', label: 'Caixa' },
            { key: 'inter', label: 'Inter' },
            { key: 'itau', label: 'Itaú' },
            { key: 'itau-personnalite', label: 'Itaú Personnalité' },
            { key: 'mercado-pago', label: 'Mercado Pago' },
            { key: 'nomad', label: 'Nomad' },
            { key: 'nubank', label: 'Nubank' },
            { key: 'picpay', label: 'PicPay' },
            { key: 'santander', label: 'Santander' },
            { key: '99pay', label: '99Pay' },
            { key: 'agibank', label: 'Agibank' },
            { key: 'agora', label: 'Ágora Investimentos' },
            { key: 'ailos', label: 'Ailos' },
            { key: 'banrisul', label: 'Banrisul' },
            { key: 'bmg', label: 'Banco BMG' },
            { key: 'bnb', label: 'Banco do Nordeste' },
            { key: 'brb', label: 'BRB' },
            { key: 'btg', label: 'BTG Pactual' },
            { key: 'bv', label: 'Banco BV' },
            { key: 'clear', label: 'Clear' },
            { key: 'contabilizei', label: 'Contabilizei' },
            { key: 'cora', label: 'Cora' },
            { key: 'cresol', label: 'Cresol' },
            { key: 'daycoval', label: 'Daycoval' },
            { key: 'digio', label: 'Digio' },
            { key: 'mercantil', label: 'Banco Mercantil' },
            { key: 'meliuz', label: 'Méliuz' },
            { key: 'neon', label: 'Neon' },
            { key: 'original', label: 'Banco Original' },
            { key: 'pan', label: 'Banco PAN' },
            { key: 'amazon', label: 'Amazon' },
            { key: 'carrefour', label: 'Carrefour' },
            { key: 'google-wallet', label: 'Google Wallet' },
            { key: 'infinitepay', label: 'InfinitePay' },
            // O seletor não tem busca: quem procura "Shopee" na grade precisa achar o nome antigo.
            { key: 'maree', label: 'Maree (ShopeePay)' },
            { key: 'pagaleve', label: 'Pagaleve' },
            { key: 'pagbank', label: 'PagBank' },
            { key: 'porto', label: 'Porto Bank' },
            { key: 'recargapay', label: 'RecargaPay' },
            { key: 'renner', label: 'Renner' },
            { key: 'revolut', label: 'Revolut' },
            { key: 'riachuelo', label: 'Riachuelo' },
            { key: 'rico', label: 'Rico' },
            { key: 'samsung-wallet', label: 'Samsung Wallet' },
            { key: 'safra', label: 'Banco Safra' },
            { key: 'sicoob', label: 'Sicoob' },
            { key: 'sicredi', label: 'Sicredi' },
            { key: 'sofisa', label: 'Sofisa' },
            { key: 'ton', label: 'Ton' },
            { key: 'unicred', label: 'Unicred' },
            // Também está em banksUs: conta internacional usada nas duas regiões, e o seletor
            // mostra só o grupo do idioma — sem a entrada aqui, quem usa em pt-BR não a acha.
            { key: 'wise', label: 'Wise' },
            { key: 'xp', label: 'XP' },
        ],
    },
    {
        id: 'banksUs',
        titleKey: 'logoSelector.groups.banksUs',
        options: [
            { key: 'chase', label: 'Chase' },
            { key: 'bank-of-america', label: 'Bank of America' },
            { key: 'wells-fargo', label: 'Wells Fargo' },
            { key: 'citi', label: 'Citi' },
            { key: 'capital-one', label: 'Capital One' },
            { key: 'us-bank', label: 'U.S. Bank' },
            { key: 'pnc', label: 'PNC' },
            { key: 'truist', label: 'Truist' },
            { key: 'td-bank', label: 'TD Bank' },
            { key: 'ally', label: 'Ally' },
            { key: 'discover', label: 'Discover' },
            { key: 'amex', label: 'American Express' },
            { key: 'schwab', label: 'Charles Schwab' },
            { key: 'robinhood', label: 'Robinhood' },
            { key: 'chime', label: 'Chime' },
            { key: 'sofi', label: 'SoFi' },
            { key: 'venmo', label: 'Venmo' },
            { key: 'cash-app', label: 'Cash App' },
            { key: 'paypal', label: 'PayPal' },
            { key: 'wise', label: 'Wise' },
        ],
    },
    {
        id: 'benefits',
        titleKey: 'logoSelector.groups.benefits',
        options: [
            { key: 'caju', label: 'Caju' },
            { key: 'ifood', label: 'iFood' },
            { key: 'alelo', label: 'Alelo' },
            { key: 'pluxee', label: 'Pluxee' },
            { key: 'ticket', label: 'Ticket' },
            { key: 'vr', label: 'VR' },
            { key: 'flash', label: 'Flash' },
            { key: 'ben', label: 'Ben' },
            { key: 'swile', label: 'Swile' },
            { key: 'wiipo', label: 'Wiipo' },
            { key: 'lecard', label: 'LeCard' },
            { key: 'vale-alimentacao', label: 'Alimentação' },
            { key: 'vale-transporte', label: 'Transporte' },
        ],
    },
];

/** Lista plana de todas as opções (deriva dos grupos) — pra consumidores que não agrupam. */
export const institutionLogoOptions: { key: InstitutionLogoKey; label: string }[] =
    institutionLogoGroups.flatMap((group) => group.options);

// Todos os logos são badge 60x60 com fundo próprio (o ícone do app, até a borda), então
// renderizam full-bleed (sem o tile de surface em volta). Derivar do map evita ter
// que manter esta lista a cada banco novo.
const institutionLogoFullBleedSet = new Set<InstitutionLogoKey>(
    Object.keys(institutionLogoMap) as InstitutionLogoKey[],
);

export function normalizeInstitutionLabel(value?: string | null) {
    return (value ?? '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, ' ')
        .trim();
}

/** Teto do texto digitado no diagnóstico: cabe o nome de qualquer banco, não cabe uma frase. */
const DIAGNOSTIC_NAME_MAX = 40;

/**
 * O banco que a pessoa escreveu no cartão, pro Sentry, quando ele NÃO está no catálogo de logos:
 * é o que diz qual banco falta. Vem o campo de banco e, vazio, o nome do cartão (quando o app não
 * reconhece o banco, o campo fica vazio e o banco está no nome). Sai sem dígito nenhum (final do
 * cartão, telefone), minúsculo, sem acento e curto. Nada escrito vira `undefined`.
 */
export function typedInstitutionForDiagnostics(institution?: string | null, cardName?: string | null): string | undefined {
    for (const source of [institution, cardName]) {
        const cleaned = normalizeInstitutionLabel(source).replace(/[0-9]/g, '').replace(/\s+/g, ' ').trim();
        if (cleaned) return cleaned.slice(0, DIAGNOSTIC_NAME_MAX).trim();
    }
    return undefined;
}

function isInstitutionLogoKey(value: string): value is InstitutionLogoKey {
    return value in institutionLogoMap;
}

function inlineClassStyles(xml: string) {
    const classStyles = new Map<string, string[]>();
    const styleRegex = /<style[^>]*>([\s\S]*?)<\/style>/g;
    let styleMatch: RegExpExecArray | null;

    while ((styleMatch = styleRegex.exec(xml)) !== null) {
        const css = styleMatch[1];
        const classRegex = /\.([a-zA-Z0-9_-]+)\s*\{([^}]+)\}/g;
        let classMatch: RegExpExecArray | null;

        while ((classMatch = classRegex.exec(css)) !== null) {
            const declarations = classMatch[2]
                .split(';')
                .map((entry) => entry.trim())
                .filter(Boolean);

            classStyles.set(classMatch[1], declarations);
        }
    }

    if (classStyles.size === 0) return xml;

    return xml
        .replace(styleRegex, '')
        .replace(/\sclass="([^"]+)"/g, (_match, classNames: string) => {
            const attrs = classNames
                .split(/\s+/)
                .flatMap((className) => classStyles.get(className) ?? [])
                .map((declaration) => {
                    const [property, value] = declaration.split(':').map((part) => part.trim());
                    return property && value ? `${property}="${value}"` : null;
                })
                .filter(Boolean);

            return attrs.length > 0 ? ` ${attrs.join(' ')}` : '';
        });
}

export function resolveInstitutionLogoKey(value?: string | null): InstitutionLogoKey | undefined {
    const normalized = normalizeInstitutionLabel(value);
    if (!normalized) return undefined;

    if (isInstitutionLogoKey(normalized)) {
        return normalized;
    }

    return (Object.entries(institutionAliases) as [InstitutionLogoKey, string[]][])
        .find(([, aliases]) => aliases.some((alias) => normalized === alias || normalized.includes(alias)))
        ?.[0];
}

/**
 * Apelidos de um emissor — como a marca aparece escrita por aí ("nu pagamentos" na
 * linha do Pix, "bradescard" na fatura do cartão de loja). Exposto porque procurar o
 * emissor dentro de um texto de notificação é o contrário de resolver uma logo: lá o
 * texto É o nome da instituição, aqui o nome está perdido numa frase inteira.
 */
export function getInstitutionAliases(key: InstitutionLogoKey): readonly string[] {
    return institutionAliases[key] ?? [];
}

const institutionLabelByKey = new Map<InstitutionLogoKey, string>(
    institutionLogoOptions.map((option) => [option.key, option.label]),
);

/** Rótulo canônico de uma instituição reconhecida (ex.: 'nubank' → 'Nubank'). */
export function getInstitutionLabelForKey(key: InstitutionLogoKey): string {
    return institutionLabelByKey.get(key) ?? key;
}

// O XML final de cada logo é imutável — cachear evita re-rodar inlineClassStyles (regex sobre
// a string inteira do SVG) a cada render de cada InstitutionLogo. Chaveado pelo key resolvido,
// então o cache é limitado ao nº de logos.
const institutionLogoXmlCache = new Map<InstitutionLogoKey, string | undefined>();

// A dupla (institutionIcon, institution) é como o cartão/conta guarda "de quem é esta
// marca": o ícone é a escolha explícita e o texto é o reconhecido pelo nome. Resolver os
// dois na mesma ordem em todo lugar é o que impede a logo, a cor e o rótulo de discordarem.
function resolveLogoKeyFromPair(
    institutionIcon?: string | null,
    institution?: string | null,
): InstitutionLogoKey | undefined {
    return institutionIcon && institutionIcon !== 'default'
        ? resolveInstitutionLogoKey(institutionIcon) ?? (isInstitutionLogoKey(institutionIcon) ? institutionIcon : undefined)
        : resolveInstitutionLogoKey(institution);
}

export function getInstitutionLogoXml(
    institutionIcon?: string | null,
    institution?: string | null,
) {
    const key = resolveLogoKeyFromPair(institutionIcon, institution);
    if (!key) return undefined;

    if (institutionLogoXmlCache.has(key)) return institutionLogoXmlCache.get(key);

    const xml = institutionLogoMap[key];
    const inlined = typeof xml === 'string' && xml.trim().length > 0 ? inlineClassStyles(xml) : undefined;
    institutionLogoXmlCache.set(key, inlined);
    return inlined;
}

export function resolveInstitutionIconValue(
    currentValue?: string | null,
    institution?: string | null,
): string {
    const normalizedInstitution = normalizeInstitutionLabel(institution);
    if (normalizedInstitution) {
        return resolveInstitutionLogoKey(normalizedInstitution) ?? 'default';
    }

    const currentKey = currentValue && currentValue !== 'default'
        ? resolveInstitutionLogoKey(currentValue) ?? (isInstitutionLogoKey(currentValue) ? currentValue : undefined)
        : undefined;

    return currentKey ?? 'default';
}

export function getInstitutionLogoLabel(value?: string | null) {
    const key = value ? resolveInstitutionLogoKey(value) ?? (isInstitutionLogoKey(value) ? value : undefined) : undefined;
    return key
        ? institutionLogoOptions.find((option) => option.key === key)?.label ?? null
        : null;
}

export function getInstitutionLogoPresentation(
    institutionIcon?: string | null,
    institution?: string | null,
) {
    const key = resolveLogoKeyFromPair(institutionIcon, institution);

    if (!key) return null;

    return {
        fullBleed: institutionLogoFullBleedSet.has(key),
        scale: institutionLogoFullBleedSet.has(key) ? 1 : 0.76,
    };
}

// A cor da marca é lida da PRÓPRIA logo: toda arte do catálogo é um badge 60x60 com um
// retângulo de fundo full-bleed, e esse fundo é, por construção, a cor que mais aparece
// nela. Ler daí (em vez de manter uma segunda tabela de cores à mão) é o que garante que
// trocar a arte de um banco troque a cor junto — a logo é a fonte única.
//
// Só as exceções ficam escritas abaixo: logo com fundo branco (o badge é a moldura, não a
// marca) e fundo em gradiente. Nesses casos a cor é a do traço que domina a arte, ou o stop
// que domina o degradê — medida no ícone da Play de onde a arte saiu, não de memória. Um
// teste falha se alguma opção do catálogo cair no branco.
const institutionBrandColorOverrides: Partial<Record<InstitutionLogoKey, string>> = {
    // Badge branco: a cor é a do desenho dentro dele.
    'bank-of-america': '#E31837',
    bv: '#002BAB',
    'capital-one': '#CC2427',
    carrefour: '#1E5BC6',
    clear: '#0500F5',
    contabilizei: '#002868',
    'google-wallet': '#4285F4',
    ifood: '#EA1D2C',
    maree: '#FF5100',
    'mercado-pago': '#00BCFF',
    revolut: '#000000',
    safra: '#00003C',
    sofisa: '#00A88F',
    ticket: '#F72717',
    // O dourado do CRED domina em pixels, mas não segura texto branco no herói do cartão.
    unicred: '#014A36',
    // Fundo em gradiente (`fill="url(#paint...)"`): a cor é o stop que domina.
    bnb: '#A6193D',
    bradesco: '#D9105D',
    caixa: '#005CA9',
    chime: '#1EC677',
    infinitepay: '#171527',
    neon: '#03A8FC',
    pagbank: '#53B645',
    picpay: '#19C661',
    pnc: '#024688',
    'samsung-wallet': '#4642F6',
    sicoob: '#003641',
    ton: '#11CA66',
    'us-bank': '#001349',
};

// O fundo de cada badge é imutável — cachear evita re-rodar o regex sobre o SVG inteiro.
const institutionBadgeFillCache = new Map<InstitutionLogoKey, string | undefined>();

function readBadgeFill(key: InstitutionLogoKey): string | undefined {
    if (institutionBadgeFillCache.has(key)) return institutionBadgeFillCache.get(key);

    const xml = institutionLogoMap[key];
    let fill: string | undefined;

    if (typeof xml === 'string') {
        for (const rect of xml.match(/<rect\b[^>]*>/gi) ?? []) {
            if (!/\bwidth="60"/.test(rect) || !/\bheight="60"/.test(rect)) continue;

            const value = /\bfill="([^"]+)"/.exec(rect)?.[1];
            // `white` é moldura, não marca — cai no override. `black` é cor de marca de
            // verdade (C6, XP, Ben). Gradiente (`url(#...)`) também cai no override.
            if (value === 'black') fill = '#000000';
            else if (value && /^#[0-9a-f]{6}$/i.test(value)) fill = value.toUpperCase();
            break;
        }
    }

    institutionBadgeFillCache.set(key, fill);
    return fill;
}

/**
 * Cor da marca de uma instituição/bandeira reconhecida — a que mais aparece na logo dela.
 * `undefined` quando não reconhecemos a marca (aí quem chama fica com a cor que já tinha).
 */
export function getInstitutionBrandColor(
    institutionIcon?: string | null,
    institution?: string | null,
): string | undefined {
    const key = resolveLogoKeyFromPair(institutionIcon, institution);
    if (!key) return undefined;

    return institutionBrandColorOverrides[key] ?? readBadgeFill(key);
}

/**
 * Bandeira da coluna `brand` -> chave da logo oficial. É o par que deixa a bandeira e o
 * banco viverem no MESMO campo do form: os dois viram uma chave de `institutionLogoMap`.
 * 'other' não tem logo — é o "não sei / não tem".
 */
export const brandLogoKeyByBrand = {
    visa: 'brand-visa',
    mastercard: 'brand-mastercard',
    elo: 'brand-elo',
    amex: 'brand-amex',
    hipercard: 'brand-hipercard',
    other: null,
} as const satisfies Record<string, InstitutionLogoKey | null>;

const brandByLogoKey = new Map<string, keyof typeof brandLogoKeyByBrand>(
    (Object.entries(brandLogoKeyByBrand) as [keyof typeof brandLogoKeyByBrand, InstitutionLogoKey | null][])
        .flatMap(([brand, key]) => (key ? [[key, brand] as const] : [])),
);

/** Bandeira correspondente a uma chave de logo, quando ela é de bandeira (senão 'other'). */
export function getBrandForLogoKey(value?: string | null): keyof typeof brandLogoKeyByBrand {
    return (value && brandByLogoKey.get(value)) || 'other';
}

/** Rótulo da bandeira ('visa' -> 'Visa'). Vazio para 'other' e para valor desconhecido. */
export function getCardBrandLabel(brand?: string | null): string {
    const key = brand ? brandLogoKeyByBrand[brand as keyof typeof brandLogoKeyByBrand] : null;
    return key ? getInstitutionLogoLabel(key) ?? '' : '';
}

export const brandFallbackMap = {
    visa: { label: 'Visa', backgroundColor: '#1A1F71', textColor: '#FFFFFF' },
    mastercard: { label: 'MC', backgroundColor: '#F79E1B', textColor: '#FFFFFF' },
    elo: { label: 'Elo', backgroundColor: '#111827', textColor: '#FFFFFF' },
    amex: { label: 'Amex', backgroundColor: '#2E77BC', textColor: '#FFFFFF' },
    hipercard: { label: 'Hiper', backgroundColor: '#C81E1E', textColor: '#FFFFFF' },
    other: null,
} as const;
